// Enums
import { TrackingDataFieldTypeLoginMethod } from '@shopee-user/tracking-login';
import { AuthenticateChannel } from '@tob/shared/thirdparty-auth/core/types';
import { LoginTrackingPoint } from '@shopee-user/tracking-constants';

export const convertChannelToTrackingInfo = (channel: AuthenticateChannel) => {
  switch (channel) {
    case AuthenticateChannel.Shopee:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyShopee,
        targetType: 'third_party_shopee',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyShopee,
      };
    case AuthenticateChannel.Google:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyGoogle,
        targetType: 'third_party_google',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyGoogle,
      };
    case AuthenticateChannel.Facebook:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyFacebook,
        targetType: 'third_party_facebook',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyFacebook,
      };
    case AuthenticateChannel.Apple:
      return {
        loginMethod: TrackingDataFieldTypeLoginMethod.ThirdPartyApple,
        targetType: 'third_party_apple',
        trackingPoint: LoginTrackingPoint.LoginWithThirdPartyApple,
      };
    default:
      return {};
  }
};
